
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz'
import { types } from 'mobx-state-tree'
import Character from '@/models/Character'
import Spell from '@/components/Spell'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h2" components={components} props={{"id":"spell-component"}}>{`Spell Component`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const character = Character.create({\n    attributes: [{ name: \'Armor Rating\' }, { name: \'Charisma\' }],\n    resources: [\n      { current: 16, maximum: 25, name: \'Mana\' },\n      { current: 5, maximum: 5, name: \'Rage\' },\n      { current: 10, maximum: 10, name: \'Willpower\' },\n    ],\n    spells: [\n      {\n        costs: [{ amount: 8, resource: \'Mana\' }],\n        description:\n          \'A powerful shielding spell, which cloaks the enchanted in radiance.\',\n        effects: [\n          { modifier: 4, modifies: \'Armor Rating\' },\n          { modifier: 2, modifies: \'Charisma\' },\n        ],\n        isActive: true,\n        level: 7,\n        name: \'Spell-Shield of the Magi\',\n      },\n    ],\n  })\n  return <Spell model={character.spells.at(0)} />\n}'} __scope={{props: this ? this.props : props,types,Character,Spell}}>
  {() => {
    const character = Character.create({
      attributes: [
        { name: 'Armor Rating' },
        { name: 'Charisma' },
      ],
      resources: [
        { current: 16, maximum: 25, name: 'Mana' },
        { current: 5, maximum: 5, name: 'Rage' },
        { current: 10, maximum: 10, name: 'Willpower' },
      ],
      spells: [{
        costs: [
          { amount: 8, resource: 'Mana' }
        ],
        description: 'A powerful shielding spell, which cloaks the enchanted in radiance.',
        effects: [
          { modifier: 4, modifies: 'Armor Rating' },
          { modifier: 2, modifies: 'Charisma' },
        ],
        isActive: true,
        level: 7,
        name: 'Spell-Shield of the Magi',
      }],
    })
return <Spell model={character.spells.at(0)} />
  }}
</Playground>
           </MDXTag>
  }
}
  